export const MENTION_PREFIX_NOTE = "@";
export const MENTION_PREFIX_COLLECTION = "#";
